module.exports = __webpack_public_path__ + "static/media/davana_1000.e288f1e9.svg";